export default __webpack_public_path__ + "static/media/ic-fee.8401ed71.svg";